<template>

	<unauthed-panel :title="$t('titles.forgot_password')">

		<v-form @submit.prevent="submit" novalidate>

			<o-text-field
				:label="$t('titles.username_or_email_address')"
				v-model.trim="v$.identifier.$model"
				prepend-inner-icon="$user"
				:validator="v$.identifier"
				autofocus
				required
				autocomplete="username"
			/>

			<div class="text-right mb-4">
				<router-link :to="{ name: 'login' }">
					{{ $t('misc.go_back_to_login') }}
				</router-link>
			</div>

			<v-btn
				type="submit"
				block
				prepend-icon="$confirm"
				:loading="submitting"
				:disabled="submitting"
			>
				{{ $t('actions.submit') }}
			</v-btn>
				
		</v-form>
		
	</unauthed-panel>

</template>

<script setup lang="ts">

import { ref, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTitle } from '@vueuse/core'
import { useRouter } from 'vue-router'
import store from '../../plugins/vuex'
import UnauthedPanel from '../UnauthedPanel.vue'
import NotificationService from '../../services/NotificationService'

// validation
import useVuelidate from '@vuelidate/core'
import { required } from '../../utils/i18n-validators'

const router = useRouter()

if (store.state.auth.status.loggedIn) {
	router.push("/organization");
}

const { t } = useI18n()
const title = useTitle()
title.value = t('titles.ocra_forgot_password')

/**
 * Form state and rules
 */

interface FormState {
  identifier: string
}

const formState = reactive<FormState>({
	identifier: '',
})

const formRules = {
  identifier: {
		required,
	},
}

const v$ = useVuelidate(formRules, formState)

/**
 * Submit
 */

const submitting = ref<boolean>(false)

async function submit() {

  const isValid = await v$.value.$validate()

  if (!isValid) {
    return
  }

  submitting.value = true

  store.dispatch('auth/forgotPassword', {username: formState.identifier})
  	.then(() => {
  		router.push({ name: 'confirmForgotPassword' })
  	})
  	.catch((error: any) => {
  		console.error(error)
  		NotificationService.error(error)
  	})
  .finally(() => {
    submitting.value = false
  })

}

</script>
